module.exports = __webpack_public_path__ + "img/plan.A-title.bbcfc748.png";